module.exports = __webpack_public_path__ + "static/media/insect(15).a0676ca6.PNG";